export default {
    view:{
        selectedDocument: false,
    selectedProducts: false,
    selectedTaxes: false,
    },
    document:null,
    audits:[]
    
}


// WEBPACK FOOTER //
// ./src/modules/audit/state.js